import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { policesAPI } from '../../services/api';
import { useAuth } from '../../contexts/AuthContext';
import DocsSouscription from './DocsSouscription';
import DateField from '../shared/DateField';
import { useLanguage } from '../../contexts/LanguageContext';
import { theme, sectionCardStyle, sectionHeaderRow, sectionTitleStyle, sectionIconWrap, sectionIntroStyle, sectionFooterStyle, primaryButtonStyle, secondaryButtonStyle } from '../../theme';

const BASE = '/api';
function authFetch(url,opts={}){
  const token=localStorage.getItem('arcus_token');
  return fetch(url,{...opts,headers:{'Content-Type':'application/json',...(opts.headers||{}),...(token?{Authorization:`Bearer ${token}`}:{})}});
}


const MAJ_K = ['maj_sports_mariages','maj_hors_ue','maj_usa_canada','maj_groupes','maj_transfert','maj_activites_risque'];
const MAJ_C = [2.00, 1.25, 1.10, 1.25, 2.00, 2.00];
const MIN_K = ['min_historique_vierge','min_experience_dirigeant'];
const MIN_C = [0.90, 0.90];

const STATUTS_STYLE = {
  devis:          { bg:'#DBEAFE', cl:'#1D4ED8', dot:'#3B82F6' },
  en_cours_etude: { bg:'#EDE9FE', cl:'#5B21B6', dot:'#8B5CF6' },
  souscrit:       { bg:'#D1FAE5', cl:'#065F46', dot:'#10B981' },
  suspendu:       { bg:'#FEE2E2', cl:'#991B1B', dot:'#EF4444' },
  resilie:        { bg:'#F1F5F9', cl:'#475569', dot:'#94A3B8' },
  sans_objet: { bg:'#F1F5F9', cl:'#94A3B8', dot:'#CBD5E1' },
};
const ORANGE = theme.orange;

// Icônes SVG inline (style Tabler, trait 1.75)
const SvgIcon = ({ size = 16, color = 'currentColor', children }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke={color} strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
    {children}
  </svg>
);
const TabIcons = {
  policy:       (c) => (<SvgIcon color={c}><path d="M14 3v4a1 1 0 0 0 1 1h4M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"/></SvgIcon>),
  tarification: (c) => (<SvgIcon color={c}><path d="M9 14c0 1.66 2.69 3 6 3s6 -1.34 6 -3M9 14c0 -1.66 2.69 -3 6 -3s6 1.34 6 3M9 14v4c0 1.66 2.69 3 6 3s6 -1.34 6 -3v-4"/></SvgIcon>),
  documents:    (c) => (<SvgIcon color={c}><path d="M5 4h4l3 3h7a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2"/></SvgIcon>),
  souscription: (c) => (<SvgIcon color={c}><path d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2M9 5a2 2 0 0 0 2 2h2a2 2 0 0 0 2 -2M9 5a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2M9 14l2 2l4 -4"/></SvgIcon>),
  underwriting: (c) => (<SvgIcon color={c}><path d="M12 3l8 4.5v9L12 21l-8 -4.5v-9zM12 12l8 -4.5M12 12v9M12 12L4 7.5M9 15.5l2 1l3 -2.5"/></SvgIcon>),
};
const SLIDE_ICON = ['policy','tarification','documents','souscription','underwriting'];

// Icônes de SECTION (style Tabler) pour les cartes internes des slides.
const SectionIconPaths = {
  client:    'M9 7a3 3 0 1 0 6 0a3 3 0 0 0 -6 0M5.5 21a6.5 6.5 0 0 1 13 0',
  risk:      'M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 14a12 12 0 0 1 -8.5 -14a12 12 0 0 0 8.5 -3M9 12l2 2l4 -4',
  status:    'M9 12l2 2l4 -4M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 14a12 12 0 0 0 8.5 -3',
  identity:  'M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2zM7 10a2 2 0 1 0 4 0a2 2 0 0 0 -4 0M7 16c0 -1 1 -2 2 -2M14 10h3M14 13h3',
  dates:     'M4 5m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2zM16 3v4M8 3v4M4 11h16',
  calc:      'M9 14c0 1.66 2.69 3 6 3s6 -1.34 6 -3M9 14c0 -1.66 2.69 -3 6 -3s6 1.34 6 3M9 14v4c0 1.66 2.69 3 6 3s6 -1.34 6 -3v-4',
  warranty:  'M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0M9 12l2 2l4 -4',
  payment:   'M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2zM3 10h18',
  documents: 'M14 3v4a1 1 0 0 0 1 1h4M5 4h4l3 3h7a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2',
};

// Carte de section uniforme (contour épais + en-tête à icône orange), comme FicheDossier.
const Section = ({ icon, title, intro, right, children, style }) => (
  <div style={{ ...sectionCardStyle, ...(style || {}) }}>
    <div style={sectionHeaderRow}>
      <div style={sectionTitleStyle}>
        {icon && (
          <span style={sectionIconWrap}>
            <SvgIcon size={16} color={ORANGE}><path d={SectionIconPaths[icon] || SectionIconPaths.documents}/></SvgIcon>
          </span>
        )}
        {title}
      </div>
      {right}
    </div>
    {intro && <div style={sectionIntroStyle}>{intro}</div>}
    {children}
  </div>
);
const ASSUREURS = ['Hiscox','Helvetia','MMA','Generali','AXA','Allianz','Autre'];

// Icône de document premium : glyphe SVG net dans une tuile arrondie teintée.
const DOC_ICON_PATHS = {
  projet:      { tint:'#EFF6FF', stroke:'#2563EB', d:'M14 3v4a1 1 0 0 0 1 1h4M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2zM9 9h1M9 13h6M9 17h6' },
  police:      { tint:'#F5F3FF', stroke:'#7C3AED', d:'M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2M9 5a2 2 0 0 0 2 2h2a2 2 0 0 0 2 -2M9 5a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2M9 12l2 2l4 -4' },
  cg:          { tint:'#ECFDF5', stroke:'#059669', d:'M3 19a9 9 0 0 1 9 0a9 9 0 0 1 9 0M3 6a9 9 0 0 1 9 0a9 9 0 0 1 9 0M3 6v13M12 6v13M21 6v13' },
  attestation: { tint:'#FEF3E2', stroke:'#F18A00', d:'M12 15a5 5 0 1 0 0 -10a5 5 0 0 0 0 10zM8.5 13.5l-1.5 6l5 -3l5 3l-1.5 -6M9.5 10l1.5 1.5l3 -3' },
};
const DocIcon = ({ type }) => {
  const cfg = DOC_ICON_PATHS[type] || DOC_ICON_PATHS.projet;
  return (
    <span style={{ width:40, height:40, borderRadius:10, background:cfg.tint, display:'inline-flex',
      alignItems:'center', justifyContent:'center', flexShrink:0 }}>
      <svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke={cfg.stroke}
        strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d={cfg.d}/></svg>
    </span>
  );
};

const fmt2 = n => n != null ? new Intl.NumberFormat('fr-FR',{minimumFractionDigits:2}).format(parseFloat(n))+' €' : '—';
const toISO = d => {
  if (!d) return '';
  const s = String(d);
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);   // date brute ou préfixe d'un ISO
  if (m) return `${m[1]}-${m[2]}-${m[3]}`;         // pas de new Date → aucun décalage de fuseau
  const dt = new Date(s);
  if (isNaN(dt)) return '';
  return `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, '0')}-${String(dt.getDate()).padStart(2, '0')}`;
};
// Affichage des dates en lecture : mois en LETTRES (non ambigu quelle que soit
// la langue). CUR_LANG est rafraîchi à chaque rendu du composant principal.
let CUR_LANG = 'fr';
const DATE_LOCALES = { fr: 'fr-FR', en: 'en-GB', de: 'de-DE', sv: 'sv-SE' };
const fmtFR = d => {
  if (!d) return '—';
  const s = String(d);
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) {
    const dt = new Date(Date.UTC(+m[1], +m[2] - 1, +m[3]));   // UTC → aucun décalage de fuseau
    return dt.toLocaleDateString(DATE_LOCALES[CUR_LANG] || 'fr-FR', { day: '2-digit', month: 'short', year: 'numeric', timeZone: 'UTC' });
  }
  const dt = new Date(s);
  return isNaN(dt) ? '—' : dt.toLocaleDateString(DATE_LOCALES[CUR_LANG] || 'fr-FR', { day: '2-digit', month: 'short', year: 'numeric' });
};
const lbl = { fontSize:12, color:'#64748B', display:'block', marginBottom:3, fontWeight:600 };
const inp = { border:'1px solid #E2E8F0', borderRadius:6, padding:'7px 10px', width:'100%', fontSize:14, boxSizing:'border-box', fontFamily:'inherit' };
const lockedField = { background:'#F8FAFC', border:'1px solid #F1F5F9', borderRadius:6, padding:'7px 10px', fontSize:14, color:'#94A3B8', minHeight:35 };

export default function FichePolice() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t, lang } = useLanguage();
  CUR_LANG = lang; // rafraîchit la locale d'affichage des dates
  const { isCourtier, isArcus, isClient, isReadOnly } = useAuth();

  // Dynamic arrays (use t() — must be inside component)
  const MAJ_Q = [t('polices.maj_q1'),t('polices.maj_q2'),t('polices.maj_q3'),t('polices.maj_q4'),t('polices.maj_q5'),t('polices.maj_q6')];
  const MIN_Q = [t('polices.min_q1'),t('polices.min_q2')];
  const ACTIVITES = [t('polices.act1'),t('polices.act2'),t('polices.act3'),t('polices.act4'),t('polices.act5')];
  const FRACS = [
    {v:'annuel',l:t('polices.freq_annual')},{v:'semestriel',l:t('polices.freq_semi')},
    {v:'trimestriel',l:t('polices.freq_quarter')},{v:'mensuel',l:t('polices.freq_month')},
  ];
  const STATUTS_LABELS = {
    devis:t('status.devis_rcpro'), en_cours_etude:t('status.en_cours_etude'),
    souscrit:t('status.souscrit'), suspendu:t('status.suspendu'),
    resilie:t('status.resilie'), sans_objet:t('status.sans_objet'),
  };
  const MOTIFS_RESIL = [
    {v:'echeance',          l:t('resiliation.motif_echeance'),    desc:t('resiliation.motif_echeance_desc'),    icon:'📅'},
    {v:'disparition_risque',l:t('resiliation.motif_disparition'), desc:t('resiliation.motif_disparition_desc'), icon:'🔕', needDate:true, prorata:true},
    {v:'aggravation_risque',l:t('resiliation.motif_aggravation'), desc:t('resiliation.motif_aggravation_desc'), icon:'⚠️', needNotif:true, prorata:true},
    {v:'non_paiement',      l:t('resiliation.motif_nonpaiement'), desc:t('resiliation.motif_nonpaiement_desc'), icon:'💳', needDate:true},
  ];
  const SLIDES_ALL = [
    { label: t('polices.tab_policy'),          idx: 0 },
    { label: t('polices.tab_tarification'),    idx: 1 },
    { label: t('polices.tab_documents'),       idx: 2 },
    { label: t('docs_souscription.title'),     idx: 3 },
    ...(isArcus ? [{ label: t('polices.tab_souscription'), idx: 4 }] : []),
  ];
  const SLIDES_VISIBLE = isClient
    ? SLIDES_ALL.filter(s => s.idx !== 0)  // client: pas de "La Police"
    : SLIDES_ALL;
  const SLIDES = SLIDES_VISIBLE.map(s => s.label);

  const [police, setPolice]         = useState(null);
  const [slide, setSlide]           = useState(0);
  useEffect(() => { if (isClient) setSlide(1); }, [isClient]);
  const [saving, setSaving]         = useState(false);
  const [error, setError]           = useState('');
  const [tarif, setTarif]           = useState(null);
  const [calculating, setCalculating] = useState(false);
  const [showSouscrire, setShowSouscrire] = useState(false);
  const [souscrireForm, setSouscrireForm] = useState({ date_effet:'', n_police:'' });
  const [souscribing, setSouscribing]     = useState(false);
  const [showRepasserConfirm, setShowRepasserConfirm] = useState(false);
  const [repassing, setRepassing]         = useState(false);
  const [docsValidation, setDocsValidation] = useState(null); // {ok, missing:[]}
  const [checkingDocs, setCheckingDocs] = useState(false);
  const [showRenewal, setShowRenewal]   = useState(false);
  const [creatingRenewal, setCreatingRenewal] = useState(false);
  const [showResil, setShowResil]       = useState(false);
  const [resilMotif, setResilMotif]     = useState('');
  const [resilDate, setResilDate]       = useState('');
  const [resilNotif, setResilNotif]     = useState('');
  const [resilNote, setResilNote]       = useState('');
  const [resilProrata, setResilProrata] = useState(null);
  const [resilSaving, setResilSaving]   = useState(false);
  const calcTimer = useRef(null);
  // Workflow de soumission RC Pro (courtier/client)
  const [docsSousStatus, setDocsSousStatus] = useState(null); // {allProvided, missingCount}
  const [showSubmitRc, setShowSubmitRc]     = useState(false);
  const [showMentionSubmit, setShowMentionSubmit] = useState(false);
  const [mentionSubmitting, setMentionSubmitting] = useState(false);
  const [mentionDecision, setMentionDecision]     = useState(null); // 'approuver' | 'reformuler' | 'refuser'
  const [reformulation, setReformulation]         = useState('');
  const [decisionBusy, setDecisionBusy]           = useState(false);
  const [submittingRc, setSubmittingRc]     = useState(false);

  const locked   = police && (police.statut === 'souscrit' || police.statut === 'resilie' || police.est_archive);
  const s1Locked = locked || isCourtier; // Slide 1 : locked for broker (view only)
  // Verrouillage de la SAISIE (dépôt de documents) pour le courtier/client :
  // ils ne peuvent déposer que tant que la police est en "Devis (en attente de pièces)".
  // Une fois soumis ('en_cours_etude') ou au-delà, tout est verrouillé pour eux.
  const rcFillLocked = locked || !!police?.mentions_verrouillees || ((isCourtier || isClient) && police?.statut !== 'devis');

  // ── Phases du workflow RC Pro ────────────────────────────────────
  // Étude du dossier : devis → en_cours_etude (Arcus).
  // La Police : souscrit / suspendu / résilié / sans objet.
  const RCPRO_SUBSCRIBED = ['souscrit', 'suspendu', 'resilie', 'sans_objet'];
  const isSubscribed = RCPRO_SUBSCRIBED.includes(police?.statut);
  const isStudy = !!police && !isSubscribed;                              // devis, en_cours_etude
  const etudeEditable = isArcus && !isReadOnly && isStudy && !locked;     // section Étude éditable par Arcus
  const datePrevLocked = !etudeEditable;                                  // date prév. éditable pendant toute l'étude

  // ── Mention spéciale + statut décliné ────────────────────────────
  const mentionVerrou  = !!police?.mentions_verrouillees;                 // verrouillage total après soumission
  const mentionStatut  = police?.mention_statut || null;                  // en_attente | approuvee | reformulee | refusee
  const isDecline      = police?.statut === 'decline';
  const mentionDecided = mentionStatut === 'approuvee' || mentionStatut === 'reformulee';
  const tarifLocked    = locked || mentionVerrou;                         // espace tarification figé après soumission
  const souscriptionEditable = isArcus && !isReadOnly;                    // onglet Souscription (Arcus)
  const RCPRO_STUDY_ORDER = ['devis', 'en_cours_etude'];
  const RCPRO_LIFECYCLE = ['souscrit', 'suspendu', 'sans_objet'];         // sélecteur restreint (résilié = flux dédié)

  useEffect(() => {
    if (!id) return;
    policesAPI.get(id).then(d => {
      setPolice(d);
      if (d.prime_ht) setTarif({ prime_ht:parseFloat(d.prime_ht), commission:parseFloat(d.commission), taxe:parseFloat(d.taxe), prime_ttc:parseFloat(d.prime_ttc), coeff_global:parseFloat(d.coefficient_global) });
    }).catch(e => setError(e.message));
  }, [id]);

  const calculer = useCallback(async (data) => {
    if (!data.ca_declare || data.ca_declare <= 0) { setTarif(null); return; }
    setCalculating(true);
    try { const res = await policesAPI.calculer(id, data); setTarif(res); }
    catch(e) {}
    finally { setCalculating(false); }
  }, [id]);

  function update(field, value) {
    if (locked) return;
    const updated = { ...police, [field]: value };
    setPolice(updated);
    const TARIF_FIELDS = ['ca_declare','fractionnement','deja_assure',...MAJ_K,...MIN_K,'ajustement_tarifaire',
      'sin_total_paye_clos','sin_nb_clos','sin_provision_ouverts','sin_part_paye_ouverts','sin_nb_ouverts','sin_nb_annees'];
    if (TARIF_FIELDS.includes(field)) {
      clearTimeout(calcTimer.current);
      calcTimer.current = setTimeout(() => calculer(updated), 600);
    }
  }

  // Courtier : peut uniquement modifier deja_assure (même si s1Locked)
  function updateDejaAssure(value) {
    if (locked) return;
    const updated = { ...police, deja_assure: value };
    setPolice(updated);
    clearTimeout(calcTimer.current);
    calcTimer.current = setTimeout(() => calculer(updated), 600);
  }

  function toggleActivite(label) {
    if (locked) return;
    const cur = police.activites_couvertes || [];
    update('activites_couvertes', cur.includes(label) ? cur.filter(a=>a!==label) : [...cur,label]);
  }

  function calcProrata(dateResil) {
    if (!police?.prime_ttc || !police.date_effet || !police.date_echeance) return null;
    const dE=new Date(police.date_effet), dEch=new Date(police.date_echeance), dR=new Date(dateResil);
    const total=Math.round((dEch-dE)/86400000), used=Math.round((dR-dE)/86400000), rem=Math.max(0,total-used);
    return { joursTotal:total, joursRestants:rem, montant:Math.round((rem/total)*parseFloat(police.prime_ttc)*100)/100 };
  }

  // Ouvre la modale de souscription (après contrôle des pièces requises).
  async function openSouscrire() {
    setCheckingDocs(true);
    try {
      const docs = await authFetch(`/api/polices/${id}/docs-souscription`).then(r => r.json());
      const missing = Array.isArray(docs) ? docs.filter(d => d.requis && d.statut !== 'accepte') : [];
      setDocsValidation({ ok: missing.length === 0, missing });
    } catch(e) {
      setDocsValidation({ ok: true, missing: [] });
    } finally {
      setCheckingDocs(false);
      setSouscrireForm({ date_effet: toISO(police.date_effet_prev) || '', n_police: police.n_police || '' });
      setShowSouscrire(true);
    }
  }

  // Souscription effective : devis/en_cours_etude → souscrit (date d'effet + n° police).
  async function doSouscrire() {
    if (!souscrireForm.date_effet) { setError(t('polices.souscrire_need_date')); return; }
    if (!souscrireForm.n_police)   { setError(t('polices.souscrire_need_npolice')); return; }
    setSouscribing(true); setError('');
    try {
      const res = await authFetch(`/api/polices/${id}/souscrire-rcpro`, {
        method: 'POST',
        body: JSON.stringify({ date_effet: souscrireForm.date_effet, n_police: souscrireForm.n_police }),
      });
      const data = await res.json();
      if (!res.ok) { setError(data.error || 'Erreur'); return; }
      setPolice(data);
      setShowSouscrire(false);
    } catch(e) { setError(e.message); }
    finally { setSouscribing(false); }
  }

  // Arcus : « Repasser en Devis » → en_cours_etude → devis, déverrouille le client.
  async function repasserDevis() {
    setRepassing(true); setError('');
    try {
      const res = await authFetch(`/api/polices/${id}/renvoyer-devis-rcpro`, { method:'POST' });
      const data = await res.json();
      if (!res.ok) { setError(data.error || 'Erreur'); return; }
      setPolice(data);
      setShowRepasserConfirm(false);
    } catch(e) { setError(e.message); }
    finally { setRepassing(false); }
  }

  // La Police : changement de statut de la vie du contrat (souscrit/suspendu/sans objet).
  async function setLifecycleStatut(v) {
    if (v === police.statut) return;
    setError('');
    try { await policesAPI.update(id, { statut: v }); setPolice(p => p ? { ...p, statut: v } : p); }
    catch(e) { setError(e.message); }
  }

  async function save() {
    setSaving(true); setError('');
    try { await policesAPI.update(id, police); }
    catch(e) { setError(e.message); }
    finally { setSaving(false); }
  }

  async function resilier() {
    setResilSaving(true);
    try {
      const body = { motif:resilMotif, note_resiliation:resilNote,
        date_notification:resilMotif==='aggravation_risque'?resilNotif:undefined,
        date_resiliation_input:['disparition_risque','non_paiement'].includes(resilMotif)?resilDate:undefined };
      const res = await authFetch(`/api/polices/${id}/resilier`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)}).then(r=>r.json());
      if (res.statut==='resilie') { setPolice(p=>({...p,statut:'resilie',est_archive:true})); setShowResil(false); }
      else setError(res.error||t('common.error'));
    } catch(e) { setError(e.message); }
    finally { setResilSaving(false); }
  }

  if (!police) return <div style={{padding:24,color:'#64748B'}}>{error||t('common.loading')}</div>;

  const ss = STATUTS_STYLE[police.statut] || STATUTS_STYLE.devis;
  const isDevis = police.statut === 'devis';

  // ── Soumission RC Pro (courtier/client) ──────────────────────────
  // La police peut être soumise si tous les documents de souscription requis
  // sont fournis. (Pas de "collecte" pour la RC Pro, contrairement à la GF.)
  const docsComplete = !!docsSousStatus?.allProvided;
  const canSubmitRc = docsComplete;

  async function submitRc() {
    setSubmittingRc(true); setError('');
    try {
      const res = await authFetch(`/api/polices/${id}/soumettre-rcpro`, { method:'POST' });
      const data = await res.json();
      if (!res.ok) { setError(data.error || 'Erreur'); return; }
      setPolice(data);
      setShowSubmitRc(false);
    } catch(e) { setError(e.message); }
    finally { setSubmittingRc(false); }
  }

  // ── Mention spéciale : soumission (client/courtier) ──────────────
  async function submitMention() {
    setMentionSubmitting(true); setError('');
    try {
      // 1. Sauvegarder TOUTES les infos de tarification saisies (CA, questions,
      //    activités exercées, mention…) avant de verrouiller — sinon elles seraient perdues.
      await policesAPI.update(id, police);
      // 2. Soumettre la mention + verrouiller la fiche.
      const res = await authFetch(`/api/polices/${id}/soumettre-mention`, {
        method:'POST', body: JSON.stringify({ mention: police.mentions_speciales }),
      });
      const data = await res.json();
      if (!res.ok) { setError(data.error || 'Erreur'); return; }
      setPolice(data);
      setShowMentionSubmit(false);
    } catch(e) { setError(e.message); }
    finally { setMentionSubmitting(false); }
  }

  // ── Mention spéciale : décision Arcus (approuver / reformuler / refuser) ──
  async function decideMention(decision) {
    if (decision === 'reformuler' && !reformulation.trim()) { setError(t('polices.mention_reformulate_empty')); return; }
    setDecisionBusy(true); setError('');
    try {
      const res = await authFetch(`/api/polices/${id}/mention-decision`, {
        method:'POST', body: JSON.stringify({ decision, texte: reformulation }),
      });
      const data = await res.json();
      if (!res.ok) { setError(data.error || 'Erreur'); return; }
      setPolice(data);
      setMentionDecision(null); setReformulation('');
    } catch(e) { setError(e.message); }
    finally { setDecisionBusy(false); }
  }

  // ── SLIDE 1 ───────────────────────────────────────────────────
  function renderS1() {
    if (isClient) return null; // slide La Police masquée pour client
    const RCPRO_STUDY_STEPS = [
      { v:'devis',          l:t('polices.rcpro_step_devis'), hint:t('polices.rcpro_step_devis_hint'), bg:STATUTS_STYLE.devis.bg,          cl:STATUTS_STYLE.devis.cl },
      { v:'en_cours_etude', l:t('status.en_cours_etude'),    hint:t('polices.rcpro_step_etude_hint'), bg:STATUTS_STYLE.en_cours_etude.bg, cl:STATUTS_STYLE.en_cours_etude.cl },
    ];
    return (
      <div>
        {/* Client */}
        <Section icon="client" title={t('polices.client_readonly')}
          right={<div style={{fontSize:13,color:theme.textSecondary}}>{police.marche_pays} · {police.type_relation==='direct'?t('clients.direct'):t('clients.brokered')}</div>}>
          <div style={{fontSize:16,fontWeight:700,color:theme.text}}>{police.client_nom}</div>
        </Section>

        {/* Risque assuré */}
        <Section icon="risk" title={t('polices.risk_insured_title')}
          intro={police.deja_assure ? t('polices.risk_insured_yes') : t('polices.risk_insured_no')}
          right={!locked ? (
            <div style={{display:'flex',gap:6}}>
              {[{v:false,l:t('common.no')},{v:true,l:t('common.yes')}].map(o=>(
                <button key={String(o.v)} onClick={()=>updateDejaAssure(o.v)}
                  style={{padding:'6px 16px',borderRadius:99,fontSize:14,cursor:'pointer',fontWeight:police.deja_assure===o.v?700:400,
                    background:police.deja_assure===o.v?'#1A1A1A':'#fff',color:police.deja_assure===o.v?'#fff':'#64748B',
                    border:`1px solid ${police.deja_assure===o.v?'#1A1A1A':'#CBD5E1'}`}}>{o.l}</button>
              ))}
            </div>
          ) : <span style={{fontSize:13,color:theme.textSecondary}}>{police.deja_assure?t('common.yes'):t('common.no')}</span>}>
          {police.deja_assure && (
            <div>
              <label style={lbl}>{t('polices.current_insurer')}</label>
              {locked
                ? <div style={lockedField}>{police.assureur_actuel||'—'}</div>
                : <select value={police.assureur_actuel||''} onChange={e=>update('assureur_actuel',e.target.value)} style={inp}>
                    <option value="">—</option>
                    {ASSUREURS.map(a=><option key={a}>{a}</option>)}
                  </select>
              }
            </div>
          )}
        </Section>

        {/* ── Étude du dossier ── */}
        <Section icon="dates" title={t('polices.etude_title')}>
        {isDecline && (
          <div style={{background:'#FEE2E2',border:'1px solid #FCA5A5',borderRadius:8,padding:'10px 12px',marginBottom:14,fontSize:13,color:'#991B1B',display:'flex',alignItems:'center',gap:8,fontWeight:600}}>
            ✕ {t('polices.dossier_decline_status')}
          </div>
        )}
        {isSubscribed && (
          <div style={{background:'#F1F5F9',border:'1px solid #E2E8F0',borderRadius:8,padding:'8px 12px',marginBottom:14,fontSize:12.5,color:'#64748B',display:'flex',alignItems:'center',gap:8}}>
            🔒 {t('polices.etude_locked_note')}
          </div>
        )}
        {/* Numéro de projet */}
        <div style={{maxWidth:340,marginBottom:16}}>
          <label style={lbl}>{t('polices.numero_projet')}</label>
          <div style={lockedField}>{police.n_devis||'—'} <span style={{fontSize:10,color:'#94A3B8',marginLeft:8}}>{t('common.auto_generated')}</span></div>
        </div>
        {/* Stepper des 2 statuts d'étude (non cliquable) */}
        <label style={lbl}>{t('polices.policy_status')}</label>
        <div style={{display:'flex',gap:8,margin:'6px 0 16px',flexWrap:'wrap'}}>
          {RCPRO_STUDY_STEPS.map((step,i)=>{
            const curIdx = RCPRO_STUDY_ORDER.indexOf(police.statut);
            const isCurrent = police.statut === step.v;
            const isDone = isSubscribed || (curIdx > i);
            const bg = isCurrent ? step.bg : (isDone ? '#ECFDF5' : '#F8FAFC');
            const bd = isCurrent ? step.cl : (isDone ? '#6EE7B7' : '#E2E8F0');
            const fg = isCurrent ? step.cl : (isDone ? '#065F46' : '#94A3B8');
            return (
              <div key={step.v} style={{flex:'1 1 220px',minWidth:200,border:`1.5px solid ${bd}`,background:bg,borderRadius:10,padding:'10px 12px'}}>
                <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:4}}>
                  <div style={{width:20,height:20,borderRadius:99,background:isCurrent?step.cl:(isDone?'#10B981':'#CBD5E1'),color:'#fff',fontSize:11,fontWeight:800,display:'flex',alignItems:'center',justifyContent:'center'}}>
                    {isDone && !isCurrent ? '✓' : i+1}
                  </div>
                  <div style={{fontSize:12.5,fontWeight:700,color:fg}}>{step.l}</div>
                </div>
                <div style={{fontSize:10.5,color:isCurrent?fg:'#94A3B8',lineHeight:1.4,paddingLeft:28}}>{step.hint}</div>
              </div>
            );
          })}
        </div>
        {/* Date d'effet prévisionnelle */}
        <div style={{maxWidth:340,marginBottom:16}}>
          <label style={lbl}>{t('polices.date_effet_prev')}</label>
          {datePrevLocked
            ? <div style={lockedField}>{fmtFR(police.date_effet_prev)}</div>
            : <DateField value={toISO(police.date_effet_prev)} onChange={v=>update('date_effet_prev', v)} style={inp}/>
          }
        </div>
        {/* Actions : repasser (secondaire) + souscrire (principal) */}
        {(etudeEditable && police.statut==='en_cours_etude') || (isArcus && !isReadOnly && isStudy) ? (
          <div style={{marginTop:16,paddingTop:16,borderTop:'1px solid #E2E8F0',display:'flex',alignItems:'center',gap:12,flexWrap:'wrap',justifyContent:'space-between'}}>
            {etudeEditable && police.statut==='en_cours_etude'
              ? <button onClick={()=>setShowRepasserConfirm(true)}
                  style={{fontSize:13,padding:'8px 15px',borderRadius:7,background:'#fff',color:'#C2410C',border:'1px solid #FCD9A6',cursor:'pointer',fontWeight:600}}>
                  ↩ {t('polices.repasser_devis_btn')}
                </button>
              : <span/>}
            {isArcus && !isReadOnly && isStudy && (
              <button onClick={openSouscrire} disabled={checkingDocs}
                style={{fontSize:14,padding:'9px 18px',borderRadius:8,background:'#059669',color:'#fff',border:'none',cursor:checkingDocs?'not-allowed':'pointer',fontWeight:700,opacity:checkingDocs?.6:1,display:'inline-flex',alignItems:'center',gap:8}}>
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M9 12l2 2l4 -4M12 3a9 9 0 1 0 0 18a9 9 0 0 0 0 -18"/></svg>
                {t('polices.souscrire_btn')}
              </button>
            )}
          </div>
        ) : null}
        </Section>

        {/* ── La Police (activée à la souscription) ── */}
        <Section icon="dates" title={t('polices.tab_policy')}>
        {isStudy && (
          <div style={{background:'#F8FAFC',border:'1px solid #E2E8F0',borderRadius:8,padding:'8px 12px',marginBottom:14,fontSize:12.5,color:'#64748B',display:'flex',alignItems:'center',gap:8}}>
            🔒 {t('polices.police_locked_note')}
          </div>
        )}
        <div style={{opacity:isStudy?.55:1}}>
          {/* Statut — sélecteur restreint (souscrit / suspendu / sans objet) ; résilié via le flux dédié */}
          <div style={{marginBottom:16}}>
            <label style={lbl}>{t('polices.policy_status')}</label>
            {isSubscribed && isArcus && !isReadOnly && police.statut!=='resilie' ? (
              <div style={{display:'flex',flexWrap:'wrap',gap:6,marginTop:5}}>
                {RCPRO_LIFECYCLE.map(v=>(
                  <button key={v} onClick={()=>setLifecycleStatut(v)}
                    style={{padding:'5px 14px',borderRadius:99,fontSize:13,cursor:'pointer',fontWeight:police.statut===v?700:400,
                      background:police.statut===v?STATUTS_STYLE[v].bg:'#fff',
                      color:police.statut===v?STATUTS_STYLE[v].cl:'#64748B',
                      border:`1px solid ${police.statut===v?STATUTS_STYLE[v].cl:'#CBD5E1'}`}}>
                    {STATUTS_LABELS[v]}
                  </button>
                ))}
              </div>
            ) : (
              <div style={{marginTop:5}}>
                <span style={{display:'inline-flex',alignItems:'center',gap:7,padding:'5px 14px',borderRadius:99,fontSize:13,fontWeight:700,background:ss.bg,color:ss.cl}}>
                  <span style={{width:8,height:8,borderRadius:99,background:ss.dot}}/>{STATUTS_LABELS[police.statut]||police.statut}
                </span>
              </div>
            )}
          </div>
          {/* N° police + date d'effet définitive */}
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12,marginBottom:16}}>
            <div>
              <label style={lbl}>{t('polices.policy_number')}</label>
              <div style={lockedField}>{police.n_police||'—'}</div>
            </div>
            <div>
              <label style={lbl}>{t('polices.effect_date')}</label>
              <div style={lockedField}>{fmtFR(police.date_effet)}</div>
            </div>
          </div>
          {/* Échéance */}
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
            <div>
              <label style={lbl}>{t('polices.expiry_date')} <span style={{fontSize:10,color:'#94A3B8'}}>{t('polices.expiry_auto')}</span></label>
              <div style={lockedField}>{fmtFR(police.date_echeance)}</div>
            </div>
          </div>
          <div style={{marginTop:10,fontSize:12,color:'#94A3B8'}}>{t('polices.renewal_note')}</div>
        </div>
        </Section>
      </div>
    );
  }

  // ── SLIDE 2 ───────────────────────────────────────────────────
  function renderS2() {
    return (
      <div>
        {/* Context badges */}
        <div style={{display:'flex',gap:7,marginBottom:14,flexWrap:'wrap'}}>
          {[`🌍 ${police.marche_pays}`,
            police.type_relation==='direct'?`⚡ ${t('polices.direct_plus15')}`:`🤝 ${t('polices.brokered_comm').replace('?',police.courtier_commission||'?')}`,
            `📄 ${t('polices.docs_in_french')}`,
          ].map((txt,i)=><span key={i} style={{fontSize:12,padding:'3px 10px',borderRadius:99,background:'#F1F5F9',border:'1px solid #E2E8F0',color:'#475569'}}>{txt}</span>)}
        </div>

        {/* Paramètres de tarification */}
        <Section icon="calc" title={t('polices.tab_tarification')}>
        {/* CA + Frac */}
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12,marginBottom:14}}>
          <div>
            <label style={lbl}>{t('polices.declared_ca')}</label>
            {tarifLocked
              ? <div style={lockedField}>{police.ca_declare?new Intl.NumberFormat('fr-FR').format(police.ca_declare)+' €':'—'}</div>
              : <input type="number" value={police.ca_declare||''} onChange={e=>update('ca_declare',parseFloat(e.target.value)||0)} placeholder="Ex. 2 500 000" style={inp}/>
            }
          </div>
          <div>
            <label style={lbl}>{t('polices.payment_freq')}</label>
            {tarifLocked
              ? <div style={lockedField}>{FRACS.find(f=>f.v===police.fractionnement)?.l||t('polices.freq_annual')}</div>
              : <select value={police.fractionnement||'annuel'} onChange={e=>update('fractionnement',e.target.value)} style={inp}>
                  {FRACS.map(f=><option key={f.v} value={f.v}>{f.l}</option>)}
                </select>
            }
          </div>
        </div>

        {/* Majorations */}
        <div style={{fontSize:11,fontWeight:700,color:'#64748B',textTransform:'uppercase',letterSpacing:'.06em',paddingBottom:6,borderBottom:'1px solid #F1F5F9',marginBottom:8}}>{t('polices.loading_factors')}</div>
        {MAJ_Q.map((q,i)=>{
          const val=police[MAJ_K[i]];
          return (
            <div key={i} style={{display:'flex',alignItems:'center',gap:8,padding:'7px 0',borderBottom:'1px solid #F8FAFC'}}>
              <div style={{flex:1,fontSize:13,color:'#475569'}}>{q}</div>
              {tarifLocked
                ? <span style={{fontSize:12,fontWeight:600,color:val?'#DC2626':'#94A3B8'}}>{val?(isArcus?`${t('common.yes')} ×${MAJ_C[i].toFixed(2)}`:t('common.yes')):t('common.no')}</span>
                : <>
                    <div style={{display:'flex',gap:5}}>
                      {[{v:true,l:t('common.yes')},{v:false,l:t('common.no')}].map(o=>(
                        <button key={String(o.v)} onClick={()=>update(MAJ_K[i],o.v)}
                          style={{padding:'3px 10px',borderRadius:99,fontSize:12,cursor:'pointer',
                            background:val===o.v?(o.v?'#FEE2E2':'#F1F5F9'):'#fff',
                            color:val===o.v?(o.v?'#DC2626':'#475569'):'#94A3B8',
                            border:`1px solid ${val===o.v?(o.v?'#FCA5A5':'#CBD5E1'):'#E2E8F0'}`,fontWeight:val===o.v?700:400}}>
                          {o.l}
                        </button>
                      ))}
                    </div>
                    {val&&isArcus&&<span style={{fontSize:11,fontWeight:700,color:'#DC2626',width:36,textAlign:'right'}}>×{MAJ_C[i].toFixed(2)}</span>}
                  </>
              }
            </div>
          );
        })}

        {/* Activités exercées */}
        <div style={{fontSize:11,fontWeight:700,color:'#64748B',textTransform:'uppercase',letterSpacing:'.06em',padding:'12px 0 6px',borderBottom:'1px solid #F1F5F9',marginBottom:8}}>{t('polices.covered_activities')}</div>
        {ACTIVITES.map((a,i)=>{
          const checked=(police.activites_couvertes||[]).includes(a);
          return (
            <label key={i} style={{display:'flex',alignItems:'flex-start',gap:8,padding:'7px 0',borderBottom:'1px solid #F8FAFC',cursor:tarifLocked?'default':'pointer',fontSize:13,color:'#475569'}}>
              <input type="checkbox" checked={checked} onChange={()=>!tarifLocked&&toggleActivite(a)} disabled={tarifLocked} style={{marginTop:2}}/>
              {a}
            </label>
          );
        })}

        {/* Mentions spéciales */}
        <div style={{fontSize:11,fontWeight:700,color:'#64748B',textTransform:'uppercase',letterSpacing:'.06em',padding:'12px 0 6px',borderBottom:'1px solid #F1F5F9',marginBottom:6}}>{t('polices.special_conditions')}</div>
        <div style={{fontSize:12,color:'#64748B',marginBottom:6}}>{t('polices.special_conditions_hint')}</div>
        {mentionVerrou ? (
          <>
            {mentionStatut==='en_attente' && (
              <div style={{background:'#FEF3E2',border:'1px solid #FCD9A6',borderRadius:7,padding:'8px 12px',marginBottom:8,fontSize:12.5,color:'#9A5A00'}}>⏳ {t('polices.mention_pending')}</div>
            )}
            {mentionDecided && (
              <div style={{background:'#ECFDF5',border:'1px solid #6EE7B7',borderRadius:7,padding:'8px 12px',marginBottom:8,fontSize:12.5,color:'#065F46'}}>✓ {mentionStatut==='reformulee'?t('polices.mention_reformulated'):t('polices.mention_approved')}</div>
            )}
            {mentionStatut==='refusee' && (
              <div style={{background:'#FEE2E2',border:'1px solid #FCA5A5',borderRadius:7,padding:'8px 12px',marginBottom:8,fontSize:12.5,color:'#991B1B'}}>✕ {t('polices.mention_refused')}</div>
            )}
            <div style={{...lockedField,minHeight:50}}>{police.mention_finale || police.mention_requete || police.mentions_speciales || '—'}</div>
          </>
        ) : (
          <>
            {(isClient||isCourtier)
              ? <textarea value={police.mentions_speciales==='Néant'?'':(police.mentions_speciales||'')}
                  onChange={e=>update('mentions_speciales',e.target.value||'Néant')}
                  placeholder={t('polices.special_conditions_placeholder')}
                  style={{...inp,minHeight:60,resize:'vertical'}}/>
              : <div style={{...lockedField,minHeight:50}}>{(police.mentions_speciales && police.mentions_speciales!=='Néant') ? police.mentions_speciales : '—'}</div>
            }
            {(isClient||isCourtier) && police.mentions_speciales && police.mentions_speciales!=='Néant' && (
              <button onClick={()=>setShowMentionSubmit(true)}
                style={{marginTop:10,fontSize:13.5,padding:'9px 16px',borderRadius:8,background:'#F18A00',color:'#fff',border:'none',cursor:'pointer',fontWeight:700,display:'inline-flex',alignItems:'center',gap:8}}>
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M10 14l11 -11M21 3l-6.5 18a.55 .55 0 0 1 -1 0l-3.5 -7l-7 -3.5a.55 .55 0 0 1 0 -1z"/></svg>
                {t('polices.mention_submit_btn')}
              </button>
            )}
          </>
        )}
        </Section>

        {/* Sinistralité */}
        {police.deja_assure && (
          <Section icon="warranty" title={`${t('polices.loss_history')} — ${t('polices.loss_takeover')} : ${police.assureur_actuel||'—'}`}>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12,marginBottom:10}}>
              <div>
                <div style={{fontSize:11,fontWeight:600,color:'#92400E',marginBottom:6}}>{t('polices.loss_closed')}</div>
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:8}}>
                  <div><label style={lbl}>{t('polices.loss_total_paid')}</label>{tarifLocked?<div style={lockedField}>{police.sin_total_paye_clos||0}</div>:<input type="number" value={police.sin_total_paye_clos||0} onChange={e=>update('sin_total_paye_clos',+e.target.value)} min="0" style={inp}/>}</div>
                  <div><label style={lbl}>{t('polices.loss_count')}</label>{tarifLocked?<div style={lockedField}>{police.sin_nb_clos||0}</div>:<input type="number" value={police.sin_nb_clos||0} onChange={e=>update('sin_nb_clos',+e.target.value)} min="0" style={inp}/>}</div>
                </div>
              </div>
              <div>
                <div style={{fontSize:11,fontWeight:600,color:'#92400E',marginBottom:6}}>{t('polices.loss_open')}</div>
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:8}}>
                  <div><label style={lbl}>{t('polices.loss_provision')}</label>{tarifLocked?<div style={lockedField}>{police.sin_provision_ouverts||0}</div>:<input type="number" value={police.sin_provision_ouverts||0} onChange={e=>update('sin_provision_ouverts',+e.target.value)} min="0" style={inp}/>}</div>
                  <div><label style={lbl}>{t('polices.loss_partial')}</label>{tarifLocked?<div style={lockedField}>{police.sin_part_paye_ouverts||0}</div>:<input type="number" value={police.sin_part_paye_ouverts||0} onChange={e=>update('sin_part_paye_ouverts',+e.target.value)} min="0" style={inp}/>}</div>
                  <div><label style={lbl}>{t('polices.loss_count')}</label>{tarifLocked?<div style={lockedField}>{police.sin_nb_ouverts||0}</div>:<input type="number" value={police.sin_nb_ouverts||0} onChange={e=>update('sin_nb_ouverts',+e.target.value)} min="0" style={inp}/>}</div>
                </div>
              </div>
            </div>
            <div style={{maxWidth:180}}>
              <label style={lbl}>{t('polices.loss_years')}</label>
              {tarifLocked?<div style={lockedField}>{police.sin_nb_annees||1}</div>:<input type="number" value={police.sin_nb_annees||1} onChange={e=>update('sin_nb_annees',+e.target.value)} min="1" max="10" style={inp}/>}
            </div>
          </Section>
        )}

        {/* Prime calculée */}
        {calculating && <div style={{marginTop:14,fontSize:13,color:'#64748B'}}>{t('common.loading')}</div>}
        {tarif && !tarif.error && !tarif.depasse_plafond && (
          <div style={{marginTop:14,background:'#D1FAE5',borderRadius:8,padding:'13px 16px',border:'1px solid #6EE7B7'}}>
            <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:10}}>
              {[{l:t('polices.net_premium'),v:fmt2(tarif.prime_ht)},{l:t('polices.commission'),v:fmt2(tarif.commission)},{l:t('polices.tax'),v:fmt2(tarif.taxe)},{l:t('polices.gross_premium'),v:fmt2(tarif.prime_ttc),big:true}].map((x,i)=>(
                <div key={i}><div style={{fontSize:10.5,color:'#065F46',marginBottom:2}}>{x.l}</div><div style={{fontSize:x.big?17:14,fontWeight:700,color:'#065F46'}}>{x.v}</div></div>
              ))}
            </div>
            {tarif.coeff_global && <div style={{marginTop:6,fontSize:11,color:'#065F46'}}>{t('polices.global_coeff')} × {Number(tarif.coeff_global).toFixed(2)}{tarif.plancher_applique&&' · '+t('polices.floor_applied')}</div>}
          </div>
        )}
        {tarif?.depasse_plafond && <div style={{marginTop:14,background:'#FEE2E2',borderRadius:8,padding:'12px 14px',color:'#991B1B',fontSize:13}}>{t('polices.above_ceiling')}</div>}
        {!police.ca_declare && <div style={{marginTop:14,fontSize:12,color:'#94A3B8'}}>{t('polices.enter_ca')}</div>}
      </div>
    );
  }

  // ── SLIDE 3 ───────────────────────────────────────────────────
  function renderS3() {
    const DOCS = [
      {key:'projet',      label:t('polices.doc_project'),      desc:t('polices.doc_project_desc'), icon:'📄', locked:false},
      {key:'police',      label:t('polices.doc_policy'),       desc:`${t('polices.policy_number')} · ${police.n_police||'—'}`, icon:'📋', locked:isDevis},
      {key:'cg',          label:t('polices.doc_cg'),           desc:'CG-F-AIE-XXI-2602', icon:'📘', locked:false},
      {key:'attestation', label:t('polices.doc_attestation'),  desc:t('polices.doc_attestation_desc'), icon:'🏅', locked:isDevis},
    ];
    return (
      <div>
        <div style={{background:'#F8FAFC',borderRadius:7,padding:'9px 13px',marginBottom:14,fontSize:13,display:'flex',alignItems:'center',gap:8}}>
          🌐 {t('polices.doc_language')}
        </div>
        {isDevis && <div style={{background:'#FEF3C7',border:'1px solid #FDE68A',borderRadius:7,padding:'9px 13px',marginBottom:14,fontSize:13,color:'#92400E'}}>{t('polices.doc_devis_warning')}</div>}

        <Section icon="documents" title={t('polices.doc_locked_docs')}>
        {DOCS.map(doc=>(
          <div key={doc.key} style={{display:'flex',alignItems:'center',gap:12,padding:'10px 13px',border:'1px solid #E2E8F0',borderRadius:8,marginBottom:8,opacity:doc.locked?.4:1,background:'#fff'}}>
            <DocIcon type={doc.key}/>
            <div style={{flex:1}}>
              <div style={{fontSize:14,fontWeight:700}}>{doc.label}</div>
              <div style={{fontSize:12,color:'#64748B',marginTop:2}}>{doc.desc}</div>
            </div>
            {doc.locked
              ? <span style={{fontSize:11,padding:'3px 9px',borderRadius:99,background:'#F1F5F9',color:'#94A3B8',border:'1px solid #E2E8F0'}}>{t('common.locked_after_binding')}</span>
              : <button onClick={async()=>{
                    try{
                      const res=await authFetch(`/api/documents/${id}/${doc.key}`);
                      if(!res.ok){const e=await res.json().catch(()=>({}));alert(t('common.error')+': '+(e.error||''));return;}
                      const blob=await res.blob();const url=URL.createObjectURL(blob);
                      const a=document.createElement('a');a.href=url;
                      const d=res.headers.get('Content-Disposition')||'';const m=d.match(/filename="(.+)"/);
                      a.download=m?m[1]:`document_${doc.key}.docx`;
                      document.body.appendChild(a);a.click();document.body.removeChild(a);URL.revokeObjectURL(url);
                    }catch(e){alert(t('common.error')+': '+e.message);}
                  }}
                  style={{fontSize:13,padding:'5px 13px',borderRadius:6,cursor:'pointer',background:'#1A1A1A',color:'#fff',border:'none',fontWeight:700}}>
                  {t('common.download')}
                </button>
            }
          </div>
        ))}
        </Section>

        <Section icon="documents" title={t('polices.internal_notes')}>
        <textarea value={police.notes_internes||''} onChange={e=>!locked&&update('notes_internes',e.target.value)}
          readOnly={locked} placeholder={t('polices.notes_placeholder')}
          style={{...inp,minHeight:80,resize:'vertical'}}/>
        </Section>
      </div>
    );
  }

  // ── SLIDE Souscription (Arcus) ────────────────────────────────
  function renderSouscription() {
    const ajust = Math.max(1, parseFloat(police.ajustement_tarifaire) || 1);
    return (
      <div>
        {isDecline && (
          <div style={{background:'#FEE2E2',border:'1px solid #FCA5A5',borderRadius:8,padding:'10px 14px',marginBottom:14,fontSize:13,fontWeight:600,color:'#991B1B'}}>
            ✕ {t('polices.dossier_decline_banner')}
          </div>
        )}

        {/* 1. Facteurs de minoration */}
        <Section icon="calc" title={t('polices.discount_factors')}>
          <div style={{fontSize:12,color:'#64748B',marginBottom:8}}>{t('polices.discount_hint')}</div>
          {MIN_Q.map((q,i)=>{
            const val=police[MIN_K[i]];
            return (
              <div key={i} style={{display:'flex',alignItems:'center',gap:8,padding:'7px 0',borderBottom:'1px solid #F8FAFC'}}>
                <div style={{flex:1,fontSize:13,color:'#475569'}}>{q}</div>
                {!souscriptionEditable
                  ? <span style={{fontSize:12,fontWeight:600,color:val?'#059669':'#94A3B8'}}>{val?`${t('common.yes')} ×${MIN_C[i].toFixed(2)}`:t('common.no')}</span>
                  : <>
                      <div style={{display:'flex',gap:5}}>
                        {[{v:true,l:t('common.yes')},{v:false,l:t('common.no')}].map(o=>(
                          <button key={String(o.v)} onClick={()=>update(MIN_K[i],o.v)}
                            style={{padding:'3px 10px',borderRadius:99,fontSize:12,cursor:'pointer',
                              background:val===o.v?(o.v?'#D1FAE5':'#F1F5F9'):'#fff',
                              color:val===o.v?(o.v?'#065F46':'#475569'):'#94A3B8',
                              border:`1px solid ${val===o.v?(o.v?'#6EE7B7':'#CBD5E1'):'#E2E8F0'}`,fontWeight:val===o.v?700:400}}>{o.l}</button>
                        ))}
                      </div>
                      {val&&<span style={{fontSize:11,fontWeight:700,color:'#059669',width:36,textAlign:'right'}}>×{MIN_C[i].toFixed(2)}</span>}
                    </>
                }
              </div>
            );
          })}
        </Section>

        {/* 2. Ajustement tarifaire */}
        <Section icon="calc" title={t('polices.ajustement_title')}>
          <div style={{fontSize:12,color:'#64748B',marginBottom:10}}>{t('polices.ajustement_hint')}</div>
          <div style={{display:'flex',alignItems:'flex-end',gap:16,flexWrap:'wrap'}}>
            <div style={{width:180}}>
              <label style={lbl}>{t('polices.ajustement_coeff')}</label>
              {souscriptionEditable
                ? <input type="number" step="0.01" min="1" value={police.ajustement_tarifaire ?? 1}
                    onChange={e=>update('ajustement_tarifaire', Math.max(1, parseFloat(e.target.value)||1))} style={inp}/>
                : <div style={lockedField}>×{ajust.toFixed(2)}</div>
              }
              <div style={{fontSize:11,color:'#94A3B8',marginTop:4}}>{t('polices.ajustement_min_note')}</div>
            </div>
            <div style={{flex:1,minWidth:160,background:'#F8FAFC',border:'1px solid #E2E8F0',borderRadius:8,padding:'10px 14px'}}>
              <div style={{fontSize:11,color:'#64748B',fontWeight:600,textTransform:'uppercase',letterSpacing:'.04em'}}>{t('polices.gross_premium')}</div>
              <div style={{fontSize:19,fontWeight:800,color:'#F18A00',marginTop:2}}>{tarif?fmt2(tarif.prime_ttc):(police.prime_ttc?fmt2(police.prime_ttc):'—')}</div>
              {ajust>1 && <div style={{fontSize:11,color:'#9A5A00',marginTop:2}}>+{((ajust-1)*100).toFixed(0)} %</div>}
            </div>
          </div>
        </Section>

        {/* 3. Mentions spéciales — revue Arcus */}
        <Section icon="policy" title={t('polices.special_conditions')}>
          {!police.mention_requete ? (
            <div style={{fontSize:12.5,color:'#94A3B8',padding:'6px 0'}}>{t('polices.mention_none')}</div>
          ) : (
            <>
              <div style={{fontSize:11.5,fontWeight:700,color:'#64748B',marginBottom:4}}>{t('polices.mention_client_request')}</div>
              <div style={{...lockedField,minHeight:44,marginBottom:10}}>{police.mention_requete}</div>
              {mentionStatut==='refusee' && <div style={{background:'#FEE2E2',border:'1px solid #FCA5A5',borderRadius:7,padding:'8px 12px',fontSize:12.5,color:'#991B1B'}}>✕ {t('polices.mention_refused')}</div>}
              {mentionDecided && (
                <div style={{background:'#ECFDF5',border:'1px solid #6EE7B7',borderRadius:7,padding:'8px 12px',fontSize:12.5,color:'#065F46'}}>
                  ✓ {mentionStatut==='reformulee'?t('polices.mention_reformulated'):t('polices.mention_approved')}
                  {police.mention_finale && <div style={{marginTop:4,color:'#334155'}}>« {police.mention_finale} »</div>}
                </div>
              )}
              {souscriptionEditable && mentionStatut==='en_attente' && (
                mentionDecision!=='reformuler' ? (
                  <div style={{display:'flex',gap:8,flexWrap:'wrap',marginTop:6}}>
                    <button onClick={()=>decideMention('approuver')} disabled={decisionBusy} style={{fontSize:13,padding:'8px 14px',borderRadius:8,background:'#059669',color:'#fff',border:'none',cursor:'pointer',fontWeight:700}}>✓ {t('polices.mention_approve')}</button>
                    <button onClick={()=>{setMentionDecision('reformuler');setReformulation(police.mention_requete||'');}} style={{fontSize:13,padding:'8px 14px',borderRadius:8,background:'#fff',color:'#185FA5',border:'1px solid #93C5FD',cursor:'pointer',fontWeight:700}}>✎ {t('polices.mention_reformulate')}</button>
                    <button onClick={()=>decideMention('refuser')} disabled={decisionBusy} style={{fontSize:13,padding:'8px 14px',borderRadius:8,background:'#fff',color:'#DC2626',border:'1px solid #FCA5A5',cursor:'pointer',fontWeight:700}}>✕ {t('polices.mention_refuse')}</button>
                  </div>
                ) : (
                  <div style={{marginTop:8}}>
                    <label style={lbl}>{t('polices.mention_reformulate_label')}</label>
                    <textarea value={reformulation} onChange={e=>setReformulation(e.target.value)} style={{...inp,minHeight:70,resize:'vertical'}}/>
                    <div style={{display:'flex',gap:8,marginTop:8}}>
                      <button onClick={()=>decideMention('reformuler')} disabled={decisionBusy||!reformulation.trim()} style={{fontSize:13,padding:'8px 16px',borderRadius:8,background:'#185FA5',color:'#fff',border:'none',cursor:'pointer',fontWeight:700,opacity:(decisionBusy||!reformulation.trim())?.5:1}}>{t('polices.mention_reformulate_confirm')}</button>
                      <button onClick={()=>{setMentionDecision(null);setReformulation('');}} style={{fontSize:13,padding:'8px 14px',borderRadius:8,background:'#fff',border:'1px solid #CBD5E1',cursor:'pointer'}}>{t('common.cancel')}</button>
                    </div>
                  </div>
                )
              )}
            </>
          )}
        </Section>

        {/* 4. Retirer l'exclusion festif */}
        <Section icon="policy" title={t('polices.exclusion_title')}>
          <label style={{display:'flex',alignItems:'flex-start',gap:10,cursor:souscriptionEditable?'pointer':'default',fontSize:13,color:'#475569'}}>
            <input type="checkbox" checked={!!police.exclusion_festif_retiree} disabled={!souscriptionEditable}
              onChange={()=>souscriptionEditable&&update('exclusion_festif_retiree',!police.exclusion_festif_retiree)} style={{marginTop:2}}/>
            <span>
              <strong>{t('polices.exclusion_remove_label')}</strong>
              <div style={{fontSize:12,color:'#94A3B8',marginTop:4,textDecoration:police.exclusion_festif_retiree?'line-through':'none'}}>{t('polices.exclusion_text')}</div>
            </span>
          </label>
          <div style={{fontSize:11.5,color:'#64748B',marginTop:8}}>
            {police.exclusion_festif_retiree ? t('polices.exclusion_removed_note') : t('polices.exclusion_present_note')}
          </div>
        </Section>
      </div>
    );
  }

  // ── Modals ────────────────────────────────────────────────────
  return (
    <>
      {/* Modal de soumission de la demande de souscription RC Pro (courtier/client) */}
      {showSubmitRc && (
        <div onClick={()=>!submittingRc && setShowSubmitRc(false)}
          style={{position:'fixed',inset:0,background:'rgba(0,0,0,.4)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1000}}>
          <div onClick={e=>e.stopPropagation()} style={{background:'#fff',borderRadius:12,padding:24,width:440,maxWidth:'90vw'}}>
            <div style={{fontSize:16,fontWeight:700,marginBottom:10,color:'#1A1A1A'}}>{t('rcpro.submit_confirm_title')}</div>
            <div style={{fontSize:13.5,color:'#475569',lineHeight:1.6,marginBottom:18}}>{t('rcpro.submit_confirm_desc')}</div>
            <div style={{display:'flex',justifyContent:'flex-end',gap:10}}>
              <button onClick={()=>setShowSubmitRc(false)} disabled={submittingRc}
                style={{padding:'8px 16px',borderRadius:8,border:'1px solid #E2E8F0',background:'#fff',cursor:'pointer'}}>
                {t('common.cancel')}
              </button>
              <button onClick={submitRc} disabled={submittingRc}
                style={{padding:'8px 18px',borderRadius:8,border:'none',background:'#F18A00',color:'#fff',fontWeight:700,cursor:submittingRc?'not-allowed':'pointer',opacity:submittingRc?.6:1}}>
                {submittingRc ? t('common.saving') : t('rcpro.submit_confirm_btn')}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal — Soumettre la requête de mention spéciale à Arcus (client/courtier) */}
      {showMentionSubmit && (
        <div onClick={()=>!mentionSubmitting && setShowMentionSubmit(false)}
          style={{position:'fixed',inset:0,background:'rgba(0,0,0,.45)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1200}}>
          <div onClick={e=>e.stopPropagation()} style={{background:'#fff',borderRadius:12,padding:24,width:460,maxWidth:'92vw'}}>
            <div style={{fontSize:16,fontWeight:700,marginBottom:8,color:'#1A1A1A'}}>{t('polices.mention_submit_confirm_title')}</div>
            <div style={{fontSize:13.5,color:'#475569',lineHeight:1.6,marginBottom:14}}>{t('polices.mention_submit_confirm_desc')}</div>
            <div style={{background:'#F8FAFC',border:'1px solid #E2E8F0',borderRadius:8,padding:'10px 12px',marginBottom:16,fontSize:13,color:'#334155',fontStyle:'italic'}}>« {police.mentions_speciales} »</div>
            {error && <div style={{background:'#FEE2E2',border:'1px solid #FCA5A5',borderRadius:7,padding:'8px 12px',marginBottom:12,fontSize:13,color:'#991B1B'}}>⚠ {error}</div>}
            <div style={{display:'flex',justifyContent:'flex-end',gap:10}}>
              <button onClick={()=>setShowMentionSubmit(false)} disabled={mentionSubmitting} style={{padding:'8px 16px',borderRadius:8,border:'1px solid #E2E8F0',background:'#fff',cursor:'pointer'}}>{t('common.cancel')}</button>
              <button onClick={submitMention} disabled={mentionSubmitting} style={{padding:'8px 18px',borderRadius:8,border:'none',background:'#F18A00',color:'#fff',fontWeight:700,cursor:mentionSubmitting?'not-allowed':'pointer',opacity:mentionSubmitting?.6:1}}>
                {mentionSubmitting ? t('common.saving') : t('polices.mention_submit_confirm_btn')}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal — Souscrire la police RC Pro (Arcus) */}
      {showSouscrire && (
        <div onClick={()=>!souscribing&&setShowSouscrire(false)} style={{position:'fixed',inset:0,background:'rgba(0,0,0,.45)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1200}}>
          <div onClick={e=>e.stopPropagation()} style={{background:'#fff',borderRadius:12,padding:24,width:460,maxWidth:'92vw'}}>
            <div style={{fontSize:16,fontWeight:700,marginBottom:6}}>{t('polices.souscrire_confirm_title')}</div>
            <div style={{fontSize:13,color:'#64748B',lineHeight:1.6,marginBottom:16}}>{t('polices.souscrire_confirm_desc')} <strong>{t('common.irreversible')}</strong></div>
            <div style={{marginBottom:12}}>
              <label style={lbl}>{t('polices.souscrire_date_label')}</label>
              <DateField value={souscrireForm.date_effet} onChange={v=>setSouscrireForm(f=>({...f,date_effet:v}))} style={inp}/>
            </div>
            <div style={{marginBottom:14}}>
              <label style={lbl}>{t('polices.souscrire_npolice_label')}</label>
              <input value={souscrireForm.n_police} onChange={e=>setSouscrireForm(f=>({...f,n_police:e.target.value}))} placeholder="Ex. QBE-2026-FR-4521" style={inp}/>
            </div>
            {docsValidation && !docsValidation.ok && (
              <div style={{background:'#FEF3C7',border:'1px solid #FDE68A',borderRadius:7,padding:'10px 14px',marginBottom:14}}>
                <div style={{fontSize:13,fontWeight:700,color:'#92400E',marginBottom:6}}>⚠ {t('polices.confirm_binding_docs_missing')}</div>
                {docsValidation.missing.map((doc,i)=>(
                  <div key={i} style={{fontSize:12.5,color:'#78350F',display:'flex',gap:6,marginBottom:2}}>
                    <span>·</span><span><strong>{doc.nom}</strong> — {doc.statut==='uploade'?t('polices.doc_waiting_approval'):t('polices.doc_not_uploaded')}</span>
                  </div>
                ))}
              </div>
            )}
            {error && <div style={{background:'#FEE2E2',border:'1px solid #FCA5A5',borderRadius:7,padding:'8px 12px',marginBottom:12,fontSize:13,color:'#991B1B'}}>⚠ {error}</div>}
            <div style={{display:'flex',justifyContent:'flex-end',gap:8}}>
              <button onClick={()=>setShowSouscrire(false)} disabled={souscribing} style={{fontSize:14,padding:'8px 16px',borderRadius:8,border:'1px solid #CBD5E1',cursor:'pointer',background:'#fff'}}>{t('common.cancel')}</button>
              <button onClick={doSouscrire} disabled={souscribing || !souscrireForm.date_effet || !souscrireForm.n_police}
                style={{fontSize:14,padding:'8px 18px',borderRadius:8,background:'#059669',color:'#fff',border:'none',cursor:(souscribing||!souscrireForm.date_effet||!souscrireForm.n_police)?'not-allowed':'pointer',fontWeight:700,opacity:(souscribing||!souscrireForm.date_effet||!souscrireForm.n_police)?.5:1}}>
                ✓ {t('polices.souscrire_confirm_btn')}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal — Repasser en Devis (Arcus) */}
      {showRepasserConfirm && (
        <div onClick={()=>!repassing&&setShowRepasserConfirm(false)} style={{position:'fixed',inset:0,background:'rgba(0,0,0,.45)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1200}}>
          <div onClick={e=>e.stopPropagation()} style={{background:'#fff',borderRadius:12,padding:24,width:480,maxWidth:'92vw'}}>
            <div style={{fontSize:16,fontWeight:700,marginBottom:8,color:'#1A1A1A'}}>{t('polices.repasser_devis_confirm_title')}</div>
            <div style={{fontSize:13.5,color:'#64748B',lineHeight:1.6,marginBottom:18}}>{t('polices.repasser_devis_confirm_desc')}</div>
            <div style={{display:'flex',justifyContent:'flex-end',gap:10}}>
              <button onClick={()=>setShowRepasserConfirm(false)} disabled={repassing} style={{fontSize:14,padding:'8px 16px',borderRadius:8,border:'1px solid #CBD5E1',background:'#fff',cursor:'pointer'}}>{t('common.cancel')}</button>
              <button onClick={repasserDevis} disabled={repassing} style={{fontSize:14,padding:'8px 18px',borderRadius:8,background:'#C2410C',color:'#fff',border:'none',cursor:'pointer',fontWeight:700,opacity:repassing?.6:1}}>{t('polices.repasser_devis_confirm_btn')}</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal renouvellement */}
      {showRenewal && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,.4)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:999}}>
          <div style={{background:'#fff',borderRadius:12,padding:24,width:440,maxWidth:'90vw'}}>
            <div style={{fontSize:15,fontWeight:700,marginBottom:12}}>{t('polices.renewal_title')}</div>
            <div style={{fontSize:13,color:'#64748B',lineHeight:1.7,marginBottom:16}}>
              {t('polices.renewal_question')} <strong style={{color:'#1A1A1A'}}>{t('polices.renewal_last_active')}</strong> ?
            </div>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10,marginBottom:16}}>
              <button onClick={async()=>{setCreatingRenewal(true);try{const res=await authFetch(`/api/polices/${id}/renouveler`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({sur_memes_bases:true})}).then(r=>r.json());if(res.id)navigate(`/polices/${res.id}`);}catch(e){setError(e.message);}finally{setCreatingRenewal(false);setShowRenewal(false);}}}
                disabled={creatingRenewal}
                style={{padding:'14px 12px',borderRadius:8,cursor:'pointer',border:'1.5px solid #059669',background:'#F0FDF4',textAlign:'left'}}>
                <div style={{fontSize:14,fontWeight:700,color:'#065F46',marginBottom:4}}>{t('polices.renewal_same')}</div>
                <div style={{fontSize:12,color:'#059669'}}>{t('polices.renewal_same_desc')}</div>
              </button>
              <button onClick={async()=>{setCreatingRenewal(true);try{const res=await authFetch(`/api/polices/${id}/renouveler`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({sur_memes_bases:false})}).then(r=>r.json());if(res.id)navigate(`/polices/${res.id}`);}catch(e){setError(e.message);}finally{setCreatingRenewal(false);setShowRenewal(false);}}}
                disabled={creatingRenewal}
                style={{padding:'14px 12px',borderRadius:8,cursor:'pointer',border:'1.5px solid #2563EB',background:'#EFF6FF',textAlign:'left'}}>
                <div style={{fontSize:14,fontWeight:700,color:'#1D4ED8',marginBottom:4}}>{t('polices.renewal_new')}</div>
                <div style={{fontSize:12,color:'#2563EB'}}>{t('polices.renewal_new_desc')}</div>
              </button>
            </div>
            <div style={{display:'flex',justifyContent:'flex-end'}}>
              <button onClick={()=>setShowRenewal(false)} style={{fontSize:14,padding:'7px 16px',borderRadius:6,border:'1px solid #CBD5E1',cursor:'pointer',background:'#fff'}}>{t('common.cancel')}</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal résiliation */}
      {showResil && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,.45)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:999}}>
          <div style={{background:'#fff',borderRadius:12,padding:24,width:480,maxWidth:'92vw',maxHeight:'90vh',overflowY:'auto'}}>
            <div style={{fontSize:15,fontWeight:700,marginBottom:14}}>{t('resiliation.title')}</div>
            <div style={{marginBottom:14}}>
              <div style={{fontSize:12,color:'#64748B',marginBottom:8,fontWeight:700}}>{t('resiliation.motif_label')}</div>
              {MOTIFS_RESIL.map(m=>(
                <button key={m.v} onClick={()=>{setResilMotif(m.v);setResilProrata(null);setResilDate('');setResilNotif('');}}
                  style={{display:'flex',alignItems:'flex-start',gap:10,width:'100%',padding:'10px 12px',marginBottom:6,
                    border:resilMotif===m.v?'1.5px solid #DC2626':'1px solid #E2E8F0',
                    borderRadius:8,cursor:'pointer',background:resilMotif===m.v?'#FFF5F5':'#fff',textAlign:'left'}}>
                  <span style={{fontSize:18,flexShrink:0}}>{m.icon}</span>
                  <div>
                    <div style={{fontSize:14,fontWeight:700,color:resilMotif===m.v?'#991B1B':'#1A1A1A'}}>{m.l}</div>
                    <div style={{fontSize:12,color:'#64748B',marginTop:2}}>{m.desc}</div>
                  </div>
                </button>
              ))}
            </div>
            {resilMotif==='aggravation_risque' && (
              <div style={{marginBottom:12}}>
                <label style={lbl}>{t('resiliation.notif_date')}</label>
                <DateField value={resilNotif} onChange={v=>{setResilNotif(v);if(v){const m=v.match(/^(\d{4})-(\d{2})-(\d{2})/);const d=new Date(Date.UTC(+m[1],+m[2]-1,+m[3]));d.setUTCDate(d.getUTCDate()+10);setResilProrata(calcProrata(d.toISOString().split('T')[0]));}}} style={inp}/>
                {resilNotif&&<div style={{fontSize:12,color:'#64748B',marginTop:4}}>{new Date(new Date(resilNotif).setDate(new Date(resilNotif).getDate()+10)).toLocaleDateString('fr-FR')} {t('resiliation.j_plus_10')}</div>}
              </div>
            )}
            {(resilMotif==='disparition_risque'||resilMotif==='non_paiement')&&(
              <div style={{marginBottom:12}}>
                <label style={lbl}>{t('resiliation.resil_date')}</label>
                <DateField value={resilDate} onChange={v=>{setResilDate(v);if(resilMotif==='disparition_risque'&&v)setResilProrata(calcProrata(v));}} style={inp}/>
              </div>
            )}
            {resilProrata&&(
              <div style={{background:'#FEF3C7',border:'1px solid #FDE68A',borderRadius:8,padding:'10px 12px',marginBottom:12}}>
                <div style={{fontSize:12,fontWeight:700,color:'#92400E',marginBottom:7}}>{t('resiliation.prorata_title')}</div>
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:8,fontSize:13}}>
                  <div><div style={{color:'#92400E',fontSize:11}}>{t('resiliation.prorata_total')}</div><strong>{resilProrata.joursTotal} {t('resiliation.prorata_days')}</strong></div>
                  <div><div style={{color:'#92400E',fontSize:11}}>{t('resiliation.prorata_remaining')}</div><strong>{resilProrata.joursRestants} {t('resiliation.prorata_days')}</strong></div>
                  <div><div style={{color:'#92400E',fontSize:11}}>{t('resiliation.prorata_refund')}</div><strong style={{fontSize:15}}>{fmt2(resilProrata.montant)}</strong></div>
                </div>
              </div>
            )}
            <div style={{marginBottom:14}}>
              <label style={lbl}>{t('resiliation.note_label')}</label>
              <textarea value={resilNote} onChange={e=>setResilNote(e.target.value)} placeholder={t('resiliation.note_placeholder')} rows={2} style={{...inp,resize:'vertical',fontFamily:'inherit'}}/>
            </div>
            <div style={{display:'flex',justifyContent:'flex-end',gap:8}}>
              <button onClick={()=>{setShowResil(false);setResilMotif('');}} style={{fontSize:14,padding:'7px 16px',borderRadius:6,border:'1px solid #CBD5E1',cursor:'pointer',background:'#fff'}}>{t('common.cancel')}</button>
              <button disabled={!resilMotif||resilSaving||(resilMotif==='aggravation_risque'&&!resilNotif)||(['disparition_risque','non_paiement'].includes(resilMotif)&&!resilDate)}
                onClick={resilier}
                style={{fontSize:14,padding:'7px 16px',borderRadius:6,background:'#DC2626',color:'#fff',border:'none',cursor:'pointer',fontWeight:700,opacity:(!resilMotif||resilSaving)?.5:1}}>
                {resilSaving?t('common.saving'):t('resiliation.confirm_btn')}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Fiche principale */}
      <div style={{margin:'0 auto'}}>
        <div style={{background:'#fff',borderRadius:10,border:'1px solid #E2E8F0',overflow:'hidden'}}>
          {/* Header clair (style "Ligne") */}
          <div style={{padding:'16px 20px',borderBottom:`2px solid ${theme.borderDark}`}}>
            <div style={{display:'flex',alignItems:'center',gap:13}}>
              <button onClick={()=>navigate(`/clients/${police.client_id}/detail`)}
                style={{background:theme.surfaceAlt,border:`0.5px solid ${theme.border}`,width:34,height:34,borderRadius:8,cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
                <SvgIcon size={18} color={theme.textSecondary}><path d="M15 6l-6 6l6 6"/></SvgIcon>
              </button>
              <div style={{width:42,height:42,borderRadius:'50%',background:theme.sidebarBg,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
                <SvgIcon size={22} color={ORANGE}><path d="M11.46 20.846a12 12 0 0 1 -7.96 -14.846a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3a12 12 0 0 1 -.09 7.06M15 19l2 2l4 -4"/></SvgIcon>
              </div>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontSize:11,color:theme.textTertiary,letterSpacing:'.04em',textTransform:'uppercase',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>
                  {t('polices.title')} · {police.client_nom}
                  {police.type_creation==='renouvellement'&&' · '+t('status.renouvellement')}
                </div>
                <div style={{fontSize:22,fontWeight:800,color:theme.text,fontFamily:'monospace'}}>
                  {police.n_police||police.n_devis||'—'}
                </div>
              </div>
              <span style={{fontSize:12,padding:'5px 13px',borderRadius:99,background:ss.bg||ss.cl,color:ss.cl,fontWeight:500,flexShrink:0,display:'inline-flex',alignItems:'center',gap:6}}>
                <span style={{width:6,height:6,borderRadius:'50%',background:ss.dot}}></span>
                {STATUTS_LABELS[police.statut]||police.statut}
              </span>
            </div>
          </div>

          {/* Onglets avec icônes */}
          <div style={{display:'flex',borderBottom:'1px solid #F1F5F9',padding:'0 14px',gap:2}}>
            {SLIDES_VISIBLE.map((s,i)=>{
              const IconFn = TabIcons[SLIDE_ICON[s.idx]] || TabIcons.policy;
              const active = slide===i;
              return (
                <button key={i} onClick={()=>setSlide(i)}
                  style={{padding:'11px 14px',fontSize:13,cursor:'pointer',background:'none',border:'none',
                    color:active?ORANGE:'#64748B',fontWeight:active?500:400,
                    borderBottom:active?`2px solid ${ORANGE}`:'2px solid transparent',
                    display:'flex',alignItems:'center',gap:7}}>
                  {IconFn(active?ORANGE:'#64748B')}
                  {s.label}
                </button>
              );
            })}
          </div>

          {/* Contenu */}
          <div style={{padding:20,minHeight:400}}>
            {isCourtier&&(
              <div style={{background:'#EFF6FF',border:'1px solid #BFDBFE',borderRadius:7,padding:'8px 12px',marginBottom:14,fontSize:13,color:'#1D4ED8'}}>
                {t('polices.broker_view_banner')}
              </div>
            )}
            {error&&<div style={{background:'#FEE2E2',color:'#991B1B',borderRadius:6,padding:'8px 12px',marginBottom:14,fontSize:14}}>{error}</div>}
            {locked&&<div style={{background:'#D1FAE5',border:'1px solid #6EE7B7',borderRadius:7,padding:'8px 12px',marginBottom:14,fontSize:13,color:'#065F46'}}>
              {police.statut==='resilie'?t('status.resilie'):t('polices.locked_banner')}
            </div>}
            {/* Demande soumise — en cours d'étude (courtier/client) */}
            {(isCourtier||isClient)&&police.statut==='en_cours_etude'&&(
              <div style={{background:'#EDE9FE',border:'1px solid #C4B5FD',borderRadius:7,padding:'10px 13px',marginBottom:14,fontSize:13,color:'#5B21B6'}}>
                {t('rcpro.submitted_banner')}
              </div>
            )}
            {/* Ce qui reste avant de pouvoir soumettre (courtier/client) : documents manquants */}
            {(isCourtier||isClient)&&police.statut==='devis'&&!canSubmitRc&&(
              <div style={{background:'#FFF7F2',border:'1px solid #FDD9BF',borderRadius:7,padding:'11px 13px',marginBottom:14}}>
                <div style={{fontSize:12.5,fontWeight:700,color:'#C2410C',marginBottom:4}}>{t('rcpro.submit_missing_title')}</div>
                <div style={{fontSize:12,color:'#7C4A03'}}>
                  <span style={{fontWeight:600}}>{t('rcpro.submit_missing_docs')}</span> {docsSousStatus?.missingCount ? `(${docsSousStatus.missingCount})` : ''}
                </div>
              </div>
            )}
            {police.type_creation==='renouvellement'&&(
              <div style={{background:'#EFF6FF',border:'1px solid #93C5FD',borderRadius:7,padding:'8px 12px',marginBottom:14,fontSize:13,color:'#1D4ED8'}}>
                🔄 {t('polices.renewal_banner')} {fmtFR(police.date_effet)} {t('polices.to')} {fmtFR(police.date_echeance)}
              </div>
            )}
            {SLIDES_VISIBLE.find((_,i)=>i===slide)?.idx===0 && renderS1()}
            {SLIDES_VISIBLE.find((_,i)=>i===slide)?.idx===1 && renderS2()}
            {SLIDES_VISIBLE.find((_,i)=>i===slide)?.idx===2 && renderS3()}
            {SLIDES_VISIBLE.find((_,i)=>i===slide)?.idx===3 && <DocsSouscription
              key={`${id}-${police?.deja_assure}-${police?.fractionnement||'annuel'}`}
              policeId={id}
              dejaAssure={police?.deja_assure}
              fractionnement={police?.fractionnement}
              readOnly={rcFillLocked}
              locked={rcFillLocked}
              onStatusChange={setDocsSousStatus}
              onPoliceStatut={(st)=>setPolice(p=>p?{...p,statut:st}:p)}
            />}
            {SLIDES_VISIBLE.find((_,i)=>i===slide)?.idx===4 && renderSouscription()}
          </div>

          {/* Footer */}
          <div style={{padding:'10px 16px',borderTop:'1px solid #F1F5F9',background:'#F8FAFC',display:'flex',alignItems:'center',justifyContent:'space-between'}}>
            <button onClick={()=>navigate(`/clients/${police.client_id}/detail`)} style={{fontSize:14,color:'#64748B',background:'none',border:'none',cursor:'pointer'}}>{t('common.close')}</button>
            <span style={{fontSize:12,color:'#94A3B8'}}>{t('common.slide')} {slide+1} / {SLIDES.length}</span>
            <div style={{display:'flex',gap:7}}>
              {slide>0&&<button onClick={()=>setSlide(s=>s-1)} style={{fontSize:14,padding:'7px 15px',borderRadius:6,border:'1px solid #CBD5E1',cursor:'pointer',background:'#fff'}}>{t('common.previous')}</button>}
              {slide<SLIDES_VISIBLE.length-1&&<button onClick={()=>setSlide(s=>s+1)} style={{fontSize:14,padding:'7px 15px',borderRadius:6,border:'1px solid #CBD5E1',cursor:'pointer',background:'#fff'}}>{t('common.next')}</button>}
              {!isReadOnly && ((!locked && (isArcus||isCourtier)) || (locked && isArcus && SLIDES_VISIBLE[slide]?.idx === 0)) && <button onClick={save} disabled={saving} style={{fontSize:14,padding:'7px 15px',borderRadius:6,background:'#1A1A1A',color:'#fff',border:'none',cursor:'pointer',fontWeight:700}}>
                {saving?t('common.saving'):'✓ '+t('common.save')}
              </button>}
              {/* Soumission de la demande de souscription (courtier/client) */}
              {(isCourtier||isClient)&&police.statut==='devis'&&<button
                onClick={()=>setShowSubmitRc(true)} disabled={!canSubmitRc}
                title={!canSubmitRc ? t('rcpro.submit_blocked_hint') : ''}
                style={{fontSize:14,padding:'7px 15px',borderRadius:6,
                  background:canSubmitRc?'#F18A00':'#E2E2DF',color:canSubmitRc?'#fff':'#9A9A95',
                  border:'none',cursor:canSubmitRc?'pointer':'not-allowed',fontWeight:700}}>
                {t('rcpro.submit_btn')}
              </button>}
              {police.statut==='souscrit'&&isArcus&&<button onClick={()=>navigate(`/amendements/nouveau/${id}`)} style={{fontSize:14,padding:'7px 15px',borderRadius:6,background:'#D97706',color:'#fff',border:'none',cursor:'pointer',fontWeight:700}}>
                {t('polices.create_amendment')}
              </button>}
              {police.statut==='souscrit'&&isArcus&&<button onClick={()=>setShowRenewal(true)} style={{fontSize:14,padding:'7px 15px',borderRadius:6,background:'#2563EB',color:'#fff',border:'none',cursor:'pointer',fontWeight:700}}>
                {t('polices.renew_btn')}
              </button>}
              {police.statut==='souscrit'&&isArcus&&<button onClick={()=>setShowResil(true)} style={{fontSize:14,padding:'7px 15px',borderRadius:6,background:'#DC2626',color:'#fff',border:'none',cursor:'pointer',fontWeight:700}}>
                {t('polices.terminate_btn')}
              </button>}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
